module.exports = __webpack_public_path__ + "img/info-7.818f747d.png";